unit Unit1;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, Vcl.StdCtrls,
  WEBLib.StdCtrls, Vcl.Controls, WEBLib.ExtCtrls, Vcl.Imaging.pngimage, WEBLib.Controls, WEBLib.Dialogs,
  WEBLib.SyntaxMemo, WEBLib.WebCtrls, web, js, libfilereader;

type
  TForm4 = class(TForm)
    WebSyntaxMemo1: TSyntaxMemo;
    WebPanel1: TPanel;
    WebComboBox1: TComboBox;
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    WebComboBox2: TComboBox;
    WebButton1: TButton;
    WebCheckBox1: TCheckBox;
    WebCheckBox2: TCheckBox;
    WebCheckBox3: TCheckBox;
    WebCheckBox4: TCheckBox;
    WebCheckBox5: TCheckBox;
    WebSpinEdit1: TSpinEdit;
    WebLabel3: TLabel;
    WebCheckBox6: TCheckBox;
    WebFilePicker1: TFilePicker;
    WebLabel4: TLabel;
    WebLabel5: TLabel;
    procedure WebComboBox1Change(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure WebComboBox2Change(Sender: TObject);
    procedure WebButton1Click(Sender: TObject);
    procedure WebCheckBox5Click(Sender: TObject);
    procedure WebCheckBox1Click(Sender: TObject);
    procedure WebCheckBox3Click(Sender: TObject);
    procedure WebCheckBox2Click(Sender: TObject);
    procedure WebCheckBox4Click(Sender: TObject);
    procedure WebSpinEdit1Change(Sender: TObject);
    procedure WebCheckBox6Click(Sender: TObject);
    procedure WebFilePicker1GetFileAsText(Sender: TObject; AFileIndex: Integer;
      AText: string);
    procedure WebFilePicker1Change(Sender: TObject);
    procedure WebSyntaxMemo1DragDrop(Sender, Source: TObject; X, Y: Integer);
    procedure WebFormUnload(Sender: TObject);
  private
    fl: Boolean;
    fr: TFileReader;
    FFileName: string;
    procedure LoadFile;
    procedure SetSyntaxMemoMode(AExtension: string);
    procedure DoReadLoaded(aFileName: string; AResult: JSValue);
  protected procedure LoadDFMValues; override; end;

var
  Form4: TForm4;

implementation

{$R *.dfm}

procedure TForm4.DoReadLoaded(aFileName: string; AResult: JSValue);
begin
  WebSyntaxMemo1.Text := JS.toString(AResult);
  FFileName := aFileName;
  SetSyntaxMemoMode(ExtractFileExt(FFileName));
end;

procedure TForm4.LoadFile;
var
  ext: string;
begin
  if Assigned(WebFilePicker1.Files[0]) then
  begin
    fl := True;
    WebFilePicker1.Files[0].GetFileAsText;
    FFileName := WebFilePicker1.Files[0].Name;
    ext := ExtractFileExt(FFileName);
    SetSyntaxMemoMode(ext);
  end;
end;

procedure TForm4.SetSyntaxMemoMode(AExtension: string);
begin
  WebSyntaxMemo1.RemovePascalKeywords;

  if AExtension = '.pas' then
  begin
    WebSyntaxMemo1.PreloadPascalKeywords;
    WebSyntaxMemo1.Mode := 'pascal';
    WebComboBox1.ItemIndex := 3;
  end
  else if AExtension = '.js' then
  begin
    WebSyntaxMemo1.Mode := 'javascript';
    WebComboBox1.ItemIndex := 2;
  end
  else if AExtension = '.css' then
  begin
    WebSyntaxMemo1.Mode := 'css';
    WebComboBox1.ItemIndex := 0;
  end
  else if (AExtension = '.html') or (AExtension = '.htm') then
  begin
    WebSyntaxMemo1.Mode := 'html';
    WebComboBox1.ItemIndex := 1;
  end
  else
  begin
    WebSyntaxMemo1.Mode := 'text';
    WebComboBox1.ItemIndex := 4;
  end;
end;

procedure TForm4.WebButton1Click(Sender: TObject);
begin
  Application.DownloadTextFile(WebSyntaxMemo1.Text, FFileName);
end;

procedure TForm4.WebCheckBox1Click(Sender: TObject);
begin
  WebSyntaxMemo1.ShowGutter := WebCheckBox1.Checked;
end;

procedure TForm4.WebCheckBox2Click(Sender: TObject);
begin
  WebSyntaxMemo1.ShowInvisibles := WebCheckBox2.Checked;
end;

procedure TForm4.WebCheckBox3Click(Sender: TObject);
begin
  WebSyntaxMemo1.ShowIndentGuides := WebCheckBox3.Checked;
end;

procedure TForm4.WebCheckBox4Click(Sender: TObject);
begin
  WebSyntaxMemo1.ShowPrintMargin := WebCheckBox4.Checked;
end;

procedure TForm4.WebCheckBox5Click(Sender: TObject);
begin
  WebSyntaxMemo1.ReadOnly := WebCheckBox5.Checked;
end;

procedure TForm4.WebCheckBox6Click(Sender: TObject);
begin
  WebSyntaxMemo1.SoftTabs := WebCheckBox6.Checked;
end;

procedure TForm4.WebComboBox1Change(Sender: TObject);
begin
  WebSyntaxMemo1.RemovePascalKeywords;

  case WebComboBox1.ItemIndex of
    0:
    begin
      WebSyntaxMemo1.Mode := 'css';
      if not fl then
        FFileName := 'demo.css';
    end;
    1:
    begin
      WebSyntaxMemo1.Mode := 'html';
      if not fl then
        FFileName := 'demo.html';
    end;
    2:
    begin
      WebSyntaxMemo1.Mode := 'javascript';
      if not fl then
        FFileName := 'demo.js';
    end;
    3:
    begin
      WebSyntaxMemo1.PreloadPascalKeywords;
      WebSyntaxMemo1.Mode := 'pascal';
      if not fl then
        FFileName := 'demo.pas';
    end;
    4:
    begin
      WebSyntaxMemo1.Mode := 'text';
      if not fl then
        FFileName := 'demo.txt';
    end;
  end;
end;

procedure TForm4.WebComboBox2Change(Sender: TObject);
begin
  case WebComboBox2.ItemIndex of
    0: WebSyntaxMemo1.Theme := 'chrome';
    1: WebSyntaxMemo1.Theme := 'cobalt';
    2: WebSyntaxMemo1.Theme := 'crimson_editor';
    3: WebSyntaxMemo1.Theme := 'monokai';
    4: WebSyntaxMemo1.Theme := 'twilight';
    5: WebSyntaxMemo1.Theme := 'xcode';
  end;
end;

procedure TForm4.WebFilePicker1Change(Sender: TObject);
begin
  LoadFile;
end;

procedure TForm4.WebFilePicker1GetFileAsText(Sender: TObject;
  AFileIndex: Integer; AText: string);
begin
  WebSyntaxMemo1.Text := AText;
end;

procedure TForm4.WebFormCreate(Sender: TObject);
begin
  WebSyntaxMemo1.PreloadPascalKeywords;
  WebSyntaxMemo1.Mode := 'pascal';
  WebSyntaxMemo1.Theme := 'crimson_editor';
  fl := False;
  FFileName := 'demo.pas';
  fr := TFileReader.Create(Self);
  fr.OnReadDone := DoReadLoaded;

  WebSyntaxMemo1.Focus;
end;

procedure TForm4.WebFormUnload(Sender: TObject);
begin
  fr.Free;
end;

procedure TForm4.WebSpinEdit1Change(Sender: TObject);
begin
  WebSyntaxMemo1.TabSize := WebSpinEdit1.Value;
end;

procedure TForm4.WebSyntaxMemo1DragDrop(Sender, Source: TObject; X, Y: Integer);
var
  f: TJSHTMLFile;
begin
  f := TJSDragEvent(TDragSourceObject(Source).Event).dataTransfer.files[0];
  if Assigned(f) then
    fr.readAsBinaryString(f);
end;

procedure TForm4.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebSyntaxMemo1 := TSyntaxMemo.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create('title');
  WebLabel5 := TLabel.Create('description');
  WebComboBox1 := TComboBox.Create(Self);
  WebComboBox2 := TComboBox.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebCheckBox1 := TCheckBox.Create(Self);
  WebCheckBox2 := TCheckBox.Create(Self);
  WebCheckBox3 := TCheckBox.Create(Self);
  WebCheckBox4 := TCheckBox.Create(Self);
  WebCheckBox5 := TCheckBox.Create(Self);
  WebSpinEdit1 := TSpinEdit.Create(Self);
  WebCheckBox6 := TCheckBox.Create(Self);
  WebFilePicker1 := TFilePicker.Create(Self);

  WebSyntaxMemo1.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebComboBox1.BeforeLoadDFMValues;
  WebComboBox2.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebCheckBox1.BeforeLoadDFMValues;
  WebCheckBox2.BeforeLoadDFMValues;
  WebCheckBox3.BeforeLoadDFMValues;
  WebCheckBox4.BeforeLoadDFMValues;
  WebCheckBox5.BeforeLoadDFMValues;
  WebSpinEdit1.BeforeLoadDFMValues;
  WebCheckBox6.BeforeLoadDFMValues;
  WebFilePicker1.BeforeLoadDFMValues;
  try
    Name := 'Form4';
    Width := 675;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -13;
    Font.Name := 'Tahoma';
    Font.Style := [];
    FormContainer := 'appcontent';
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnUnload', 'WebFormUnload');
    WebSyntaxMemo1.SetParentComponent(Self);
    WebSyntaxMemo1.Name := 'WebSyntaxMemo1';
    WebSyntaxMemo1.Left := 193;
    WebSyntaxMemo1.Top := 0;
    WebSyntaxMemo1.Width := 482;
    WebSyntaxMemo1.Height := 500;
    WebSyntaxMemo1.Align := alClient;
    WebSyntaxMemo1.TabOrder := 0;
    SetEvent(WebSyntaxMemo1, Self, 'OnDragDrop', 'WebSyntaxMemo1DragDrop');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 193;
    WebPanel1.Height := 500;
    WebPanel1.Align := alLeft;
    WebPanel1.Color := clSilver;
    WebPanel1.TabOrder := 1;
    WebLabel1.SetParentComponent(WebPanel1);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 8;
    WebLabel1.Top := 11;
    WebLabel1.Width := 38;
    WebLabel1.Height := 19;
    WebLabel1.Caption := 'Mode';
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clWindowText;
    WebLabel1.Font.Height := -16;
    WebLabel1.Font.Name := 'Tahoma';
    WebLabel1.Font.Style := [];
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.ParentFont := False;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(WebPanel1);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 8;
    WebLabel2.Top := 72;
    WebLabel2.Width := 49;
    WebLabel2.Height := 19;
    WebLabel2.Caption := 'Theme';
    WebLabel2.Font.Charset := DEFAULT_CHARSET;
    WebLabel2.Font.Color := clWindowText;
    WebLabel2.Font.Height := -16;
    WebLabel2.Font.Name := 'Tahoma';
    WebLabel2.Font.Style := [];
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.ParentFont := False;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(WebPanel1);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 8;
    WebLabel3.Top := 141;
    WebLabel3.Width := 48;
    WebLabel3.Height := 16;
    WebLabel3.Caption := 'Tab size';
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(WebPanel1);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 24;
    WebLabel4.Top := 392;
    WebLabel4.Width := 109;
    WebLabel4.Height := 16;
    WebLabel4.Caption := 'SyntaxMemo demo';
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel5.SetParentComponent(WebPanel1);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 24;
    WebLabel5.Top := 414;
    WebLabel5.Width := 204;
    WebLabel5.Height := 16;
    WebLabel5.Caption := 'Usage of TWebSyntaxMemo control';
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.WidthPercent := 100.000000000000000000;
    WebComboBox1.SetParentComponent(WebPanel1);
    WebComboBox1.Name := 'WebComboBox1';
    WebComboBox1.Left := 8;
    WebComboBox1.Top := 33;
    WebComboBox1.Width := 177;
    WebComboBox1.Height := 24;
    WebComboBox1.HeightPercent := 100.000000000000000000;
    WebComboBox1.Text := 'Pascal';
    WebComboBox1.WidthPercent := 100.000000000000000000;
    SetEvent(WebComboBox1, Self, 'OnChange', 'WebComboBox1Change');
    WebComboBox1.ItemIndex := 3;
    WebComboBox1.Items.BeginUpdate;
    try
      WebComboBox1.Items.Clear;
      WebComboBox1.Items.Add('CSS');
      WebComboBox1.Items.Add('HTML');
      WebComboBox1.Items.Add('Javascript');
      WebComboBox1.Items.Add('Pascal');
      WebComboBox1.Items.Add('Text');
    finally
      WebComboBox1.Items.EndUpdate;
    end;
    WebComboBox2.SetParentComponent(WebPanel1);
    WebComboBox2.Name := 'WebComboBox2';
    WebComboBox2.Left := 8;
    WebComboBox2.Top := 94;
    WebComboBox2.Width := 177;
    WebComboBox2.Height := 24;
    WebComboBox2.HeightPercent := 100.000000000000000000;
    WebComboBox2.Text := 'Crimson Editor';
    WebComboBox2.WidthPercent := 100.000000000000000000;
    SetEvent(WebComboBox2, Self, 'OnChange', 'WebComboBox2Change');
    WebComboBox2.ItemIndex := 2;
    WebComboBox2.Items.BeginUpdate;
    try
      WebComboBox2.Items.Clear;
      WebComboBox2.Items.Add('Chrome');
      WebComboBox2.Items.Add('Cobalt');
      WebComboBox2.Items.Add('Crimson Editor');
      WebComboBox2.Items.Add('Monokai');
      WebComboBox2.Items.Add('Twilight');
      WebComboBox2.Items.Add('Xcode');
    finally
      WebComboBox2.Items.EndUpdate;
    end;
    WebButton1.SetParentComponent(WebPanel1);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 8;
    WebButton1.Top := 335;
    WebButton1.Width := 177;
    WebButton1.Height := 29;
    WebButton1.Caption := 'Download';
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
    WebCheckBox1.SetParentComponent(WebPanel1);
    WebCheckBox1.Name := 'WebCheckBox1';
    WebCheckBox1.Left := 8;
    WebCheckBox1.Top := 185;
    WebCheckBox1.Width := 113;
    WebCheckBox1.Height := 22;
    WebCheckBox1.Caption := 'Show gutter';
    WebCheckBox1.Checked := True;
    WebCheckBox1.HeightPercent := 100.000000000000000000;
    WebCheckBox1.State := cbChecked;
    WebCheckBox1.WidthPercent := 100.000000000000000000;
    SetEvent(WebCheckBox1, Self, 'OnClick', 'WebCheckBox1Click');
    WebCheckBox2.SetParentComponent(WebPanel1);
    WebCheckBox2.Name := 'WebCheckBox2';
    WebCheckBox2.Left := 8;
    WebCheckBox2.Top := 228;
    WebCheckBox2.Width := 113;
    WebCheckBox2.Height := 22;
    WebCheckBox2.Caption := 'Show invisibles';
    WebCheckBox2.HeightPercent := 100.000000000000000000;
    WebCheckBox2.WidthPercent := 100.000000000000000000;
    SetEvent(WebCheckBox2, Self, 'OnClick', 'WebCheckBox2Click');
    WebCheckBox3.SetParentComponent(WebPanel1);
    WebCheckBox3.Name := 'WebCheckBox3';
    WebCheckBox3.Left := 8;
    WebCheckBox3.Top := 206;
    WebCheckBox3.Width := 129;
    WebCheckBox3.Height := 22;
    WebCheckBox3.Caption := 'Show indent guides';
    WebCheckBox3.Checked := True;
    WebCheckBox3.HeightPercent := 100.000000000000000000;
    WebCheckBox3.State := cbChecked;
    WebCheckBox3.WidthPercent := 100.000000000000000000;
    SetEvent(WebCheckBox3, Self, 'OnClick', 'WebCheckBox3Click');
    WebCheckBox4.SetParentComponent(WebPanel1);
    WebCheckBox4.Name := 'WebCheckBox4';
    WebCheckBox4.Left := 8;
    WebCheckBox4.Top := 249;
    WebCheckBox4.Width := 137;
    WebCheckBox4.Height := 22;
    WebCheckBox4.Caption := 'Show print margins';
    WebCheckBox4.Checked := True;
    WebCheckBox4.HeightPercent := 100.000000000000000000;
    WebCheckBox4.State := cbChecked;
    WebCheckBox4.WidthPercent := 100.000000000000000000;
    SetEvent(WebCheckBox4, Self, 'OnClick', 'WebCheckBox4Click');
    WebCheckBox5.SetParentComponent(WebPanel1);
    WebCheckBox5.Name := 'WebCheckBox5';
    WebCheckBox5.Left := 8;
    WebCheckBox5.Top := 164;
    WebCheckBox5.Width := 113;
    WebCheckBox5.Height := 22;
    WebCheckBox5.Caption := 'Read only';
    WebCheckBox5.HeightPercent := 100.000000000000000000;
    WebCheckBox5.WidthPercent := 100.000000000000000000;
    SetEvent(WebCheckBox5, Self, 'OnClick', 'WebCheckBox5Click');
    WebSpinEdit1.SetParentComponent(WebPanel1);
    WebSpinEdit1.Name := 'WebSpinEdit1';
    WebSpinEdit1.Left := 62;
    WebSpinEdit1.Top := 139;
    WebSpinEdit1.Width := 52;
    WebSpinEdit1.Height := 22;
    WebSpinEdit1.AutoSize := False;
    WebSpinEdit1.BorderStyle := bsSingle;
    WebSpinEdit1.Color := clWhite;
    WebSpinEdit1.Increment := 1;
    WebSpinEdit1.MaxValue := 50;
    WebSpinEdit1.MinValue := 1;
    WebSpinEdit1.Role := '';
    WebSpinEdit1.Value := 2;
    SetEvent(WebSpinEdit1, Self, 'OnChange', 'WebSpinEdit1Change');
    WebCheckBox6.SetParentComponent(WebPanel1);
    WebCheckBox6.Name := 'WebCheckBox6';
    WebCheckBox6.Left := 8;
    WebCheckBox6.Top := 272;
    WebCheckBox6.Width := 113;
    WebCheckBox6.Height := 22;
    WebCheckBox6.Caption := 'Soft tabs';
    WebCheckBox6.Checked := True;
    WebCheckBox6.HeightPercent := 100.000000000000000000;
    WebCheckBox6.State := cbChecked;
    WebCheckBox6.WidthPercent := 100.000000000000000000;
    SetEvent(WebCheckBox6, Self, 'OnClick', 'WebCheckBox6Click');
    WebFilePicker1.SetParentComponent(Self);
    WebFilePicker1.Name := 'WebFilePicker1';
    WebFilePicker1.Left := 8;
    WebFilePicker1.Top := 300;
    WebFilePicker1.Width := 177;
    WebFilePicker1.Height := 29;
    SetEvent(WebFilePicker1, Self, 'OnChange', 'WebFilePicker1Change');
    SetEvent(WebFilePicker1, Self, 'OnGetFileAsText', 'WebFilePicker1GetFileAsText');
  finally
    WebSyntaxMemo1.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebComboBox1.AfterLoadDFMValues;
    WebComboBox2.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebCheckBox1.AfterLoadDFMValues;
    WebCheckBox2.AfterLoadDFMValues;
    WebCheckBox3.AfterLoadDFMValues;
    WebCheckBox4.AfterLoadDFMValues;
    WebCheckBox5.AfterLoadDFMValues;
    WebSpinEdit1.AfterLoadDFMValues;
    WebCheckBox6.AfterLoadDFMValues;
    WebFilePicker1.AfterLoadDFMValues;
  end;
end;

end.



